module.exports = __webpack_public_path__ + "static/media/1.77ff2a2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Hero/1.jpg
// module id = 250
// module chunks = 0